import { c as _c } from "react/compiler-runtime";
// One icon + label + value line inside a details card. Rows share a single
// card background/rounding provided by the parent list wrapper (see
// ClientDetailsCard/ProjectDetailsCard) with dividers between them, so this
// only owns its own padding/layout. `icon` is a rendered element (not a
// component reference) so callers can mix MUI icons and plain <Image> icons
// (e.g. the custom contract_edit.svg) side by side.
export default function DetailRow(t0) {
  const $ = _c(14);
  const {
    icon,
    label,
    value,
    fallback: t1
  } = t0;
  const fallback = t1 === undefined ? "Not specified" : t1;
  const hasValue = Boolean(value);
  let t2;
  if ($[0] !== icon) {
    t2 = <div className="mt-0.5 shrink-0 text-[--colorDisabledDisabled]">{icon}</div>;
    $[0] = icon;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== label) {
    t3 = <span className="m3-label-small text-[--textDisabledDisabled]">{label}</span>;
    $[2] = label;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== fallback || $[5] !== hasValue || $[6] !== value) {
    t4 = hasValue ? <span className="m3-body-medium whitespace-pre-line text-[--textPrimaryPrimary]">{value}</span> : <span className="m3-body-medium text-[--textErrorErrorText]">{fallback}</span>;
    $[4] = fallback;
    $[5] = hasValue;
    $[6] = value;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className="flex flex-col gap-1">{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t2 || $[12] !== t5) {
    t6 = <div className="flex items-start gap-4 p-4">{t2}{t5}</div>;
    $[11] = t2;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}